export default function minutesToHoursMinutesString(
    minutes: number,
    hoursPostfix = "h",
    minutesPostfix = "m",
    separator = '',
    forceShow = false
) {
    const { hours = 0, mins = 0 } = gd.utils.minutesToHM(minutes)

    const showHours = hours || forceShow
    const showMins = mins || forceShow

    if (!showHours && !showMins) {
        return `0${hoursPostfix}`
    }

    let parts: string[] = []

    if (showHours) {
        parts.push(`${hours}${hoursPostfix}`)
    }
    if (separator && parts.length > 0) {
        parts.push(separator)
    }
    if (showMins) {
        parts.push(`${mins}${minutesPostfix}`)
    }

    return parts.join(' ').trim()
}

